export interface AdmissionStep {
    id: number
    title: string
    description: string
    icon: string
}

export interface TuitionFee {
    year: string
    price: string
    details: string
}

export interface AdmissionsConfig {
    steps: AdmissionStep[]
    fees: TuitionFee[]
    nextSession: string
    registrationFee: string
}

// Default data (fallback)
const defaultSteps: AdmissionStep[] = [
    {
        id: 1,
        title: 'Candidature en ligne',
        description: 'Remplissez le formulaire de candidature et déposez votre dossier (CV, lettre de motivation, portfolio si disponible).',
        icon: 'fa-file-alt'
    },
    {
        id: 2,
        title: 'Entretien de motivation',
        description: 'Échangez avec notre équipe pédagogique pour présenter votre projet professionnel et votre passion pour le jeu vidéo.',
        icon: 'fa-comments'
    },
    {
        id: 3,
        title: 'Tests techniques',
        description: 'Démontrez votre potentiel à travers des tests de logique et de créativité adaptés à la formation choisie.',
        icon: 'fa-laptop-code'
    },
    {
        id: 4,
        title: 'Admission définitive',
        description: 'Finalisez votre dossier et rejoignez la prochaine promotion.',
        icon: 'fa-check-circle'
    }
]

const defaultFees: TuitionFee[] = [
    {
        year: 'Année 1 & 2 (Prépa)',
        price: '6 500 € / an',
        details: 'Socle commun et fondamentaux'
    },
    {
        year: 'Année 3 (Bachelor)',
        price: '7 200 € / an',
        details: 'Spécialisation métier'
    },
    {
        year: 'Année 4 & 5 (Mastère)',
        price: '7 800 € / an',
        details: 'Expertise et production studio'
    }
]

export const useAdmissions = () => {
    const config = useRuntimeConfig()
    const apiBase = config.public.apiBase

    const getAdmissionsConfig = async (): Promise<AdmissionsConfig> => {
        try {
            const { data, error } = await useFetch<AdmissionsConfig>(`${apiBase}/oxoweb/admissions`)
            if (error.value || !data.value) {
                console.error('Error fetching admissions config:', error.value)
                return {
                    steps: defaultSteps,
                    fees: defaultFees,
                    nextSession: 'Rentrée décalée : Février 2025',
                    registrationFee: '450 € / an'
                }
            }
            return data.value
        } catch (e) {
            console.error('Error fetching admissions config:', e)
            return {
                steps: defaultSteps,
                fees: defaultFees,
                nextSession: 'Rentrée décalée : Février 2025',
                registrationFee: '450 € / an'
            }
        }
    }

    // Sync versions for backward compatibility (will use async internally)
    const getAdmissionSteps = () => defaultSteps
    const getTuitionFees = () => defaultFees
    const getNextSession = () => 'Rentrée décalée : Février 2025'

    return {
        getAdmissionsConfig,
        getAdmissionSteps,
        getTuitionFees,
        getNextSession
    }
}

